<template>
  <div class="bb-user-card">
    <transition name="fade" appear>
      <LoaderFly v-if="loaderRun"/>
    </transition>
    <div class="bb-user-card-left"
         :class="{'bb-user-card-left_active': activePart === 'left'}"
         @click="setActivePart('left')"
         @mouseenter="setActivePart('left')"
    >
      <UserForm :user="userInfo"/>
    </div>
    <div class="bb-user-card-right">
      <div class="bb-user-card-right-info-one">
        <div class="bb-user-card-right-info-one__chart">
          <UserStatistics :userKpi="userKpi"/>
        </div>
        <UserKPI :userKpi="userKpi"/>
        <UserEarned :userKpi="userKpi"/>
        <UserProjects :userKpi="userKpi"
                      @openItem="openInfoTable"
        />
      </div>
      <div class="bb-user-card-right-info-two">
        <div class="bb-user-card-right-info-two__item">Training & Development</div>
        <div class="bb-user-card-right-info-two__item">My accumulated vacation</div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="openEarned"
                   @close="openEarned = false, activeColumn = ''"
                   :table-mode="true"
                   :title="titleModal"
      >
        <div class="bb-user-card-modal">
          <div class="bb-user-card-modal-total">
            <span class="bb-user-card-modal-total__text">
              TOTAL AED {{numeralConvertNumber(total)}}
            </span>
          </div>
          <BBTable :columns="kpiEarnedColumnsData"
                   :rows="kpiEarnedRowsData"
                   @sort="setSort"
                   v-if="kpiEarnedRowsData.length >= 1"
          />
          <TableNoData v-else :description="descriptionText"/>
        </div>
      </ModalWindow>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="proformaOpen"
                   @close="proformaOpen = false"
      >
        <ProformaInvoice @close="proformaOpen = false"
                         :view-mode="true"
                         :editable-invoice="editableInvoice"/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import UsersListApi from '@/api/UsersList/api'
import UserForm from '@/components/Settings/UserCard/UserForm/UserForm'
import BBTable from '@/components/Main/BBTable/BBTable'
import UserStatistics from '@/components/Settings/UserCard/UserStatistics/UserStatistics'
import UserKPI from '@/components/Settings/UserCard/UserKPI/UserKPI'
import UserEarned from '@/components/Settings/UserCard/UserEarned/UserEarned'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import TableNoData from '@/components/Main/BBTable/TableNoData/TableNoData'
import UserProjects from '@/components/Settings/UserCard/UserProjects/UserProjects'
import ProformaInvoice from '@/components/Dissemination/Sales/CRM/ContactCard/ProformaInvoice/ProformaInvoice'
import totalCompletedTable from '@/constants/TablesOptions/totalCompletedTable'
import totalPotentialTable from '@/constants/TablesOptions/totalPotentialTable'
import pendingApprovalTable from '@/constants/TablesOptions/pendingApprovalTable'
import convertNumber from '@/mixin/convertNumber'
import InvoicesApi from '@/api/Invoce/api'
import KpiApi from '@/api/Kpi/api'
import {get, set} from 'lodash'
import moment from 'moment'
export default {
  name: 'UserCard',
  mixins: [convertNumber],
  components: {
    UserForm,
    UserStatistics,
    UserKPI,
    UserProjects,
    UserEarned,
    TableNoData,
    BBTable,
    LoaderFly,
    ProformaInvoice,
    ModalWindow
  },
  computed: {
    kpiEarnedColumnsData: {
      get: function () {
        return this.$store.getters.kpiEarnedColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setKpiEarnedColumnsData', data)
      }
    },
    kpiEarnedRowsData: {
      get: function () {
        return this.$store.getters.kpiEarnedRowsData
      },
      set: function (data) {
        this.$store.dispatch('setKpiEarnedRowsData', data)
      }
    }
  },
  data () {
    return {
      activePart: '',
      userKpi: {},
      userInfo: {},
      department: 0,
      loaderRun: false,
      total: 0,
      activeColumn: '',
      titleModal: '',
      openEarned: false,
      descriptionText: 'Sorry, but not found Data',
      proformaOpen: false,
      sort: '',
      editableInvoice: {
        invoice: {}
      }
    }
  },
  methods: {
    setActivePart (part) {
      this.activePart = part
    },
    async openInfoTable (type, total) {
      this.total = total
      const {position, _id} = this.userKpi
      const {department} = position
      const userType = position ? department : false
      const query = {
        column: type,
        userID: _id,
        userTypeID: userType,
        sort: this.sort
      }
      await this.getServicesByManager(query)
      this.activeColumn = type
      let title = ''
      if (this.activeColumn === 'potential') {
        this.kpiEarnedColumnsData = totalPotentialTable
        title = 'Total Potential'
      } else if (this.activeColumn === 'earned') {
        this.kpiEarnedColumnsData = totalCompletedTable
        title = 'Total Completed'
      } else {
        this.kpiEarnedColumnsData = pendingApprovalTable
        title = 'Pending approval'
      }
      this.titleModal = title
      this.addActionsInfo()
      this.openEarned = true
    },
    addActionsInfo () {
      const item = this.kpiEarnedColumnsData.find((item) => item.actionType === 'openProforma')
      if (!item) return
      item.action = this.openProforma
    },
    setSort (value, column) {
      this.sort = value
      const [kpi] = this.kpiEarnedRowsData
      const {position, user} = kpi
      const type = position ? position.department : false
      const {mark} = column
      const query = {
        column: mark,
        userID: user,
        userTypeID: type,
        sort: this.sort
      }
      this.getServicesByManager(query)
    },
    openProforma (row) {
      const id = get(row, 'invoice.id', false)
      if (!id) return
      this.loaderRun = true
      InvoicesApi.getInvoiceById(id)
        .then(({data}) => {
          this.editableInvoice = {
            invoice: data
          }
          this.proformaOpen = true
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    async getServicesByManager (query) {
      this.loaderRun = true
      const {data, status} = await KpiApi.getKPIByUser(query)
      if (status !== 200) {
        this.loaderRun = false
        return
      }
      this.kpiEarnedRowsData = data.map(item => {
        item['factKPI.approvalValue'] = get(item, ['factKPI', 'approvalValue'], 0)
        const serviceName = get(item, ['service', 'name'], '')
        if (query.column !== 'earned') {
          set(item, ['service', 'name'], this.setColorServiceName(serviceName, item.paymentDate))
        }
        if ((item.currentValue - item.approvedValue) <= 0 && (query.column === 'potential')) {
          item.static = true
        }
        return item
      })
      this.loaderRun = false
    },
    setColorServiceName (serviceName, paymentDate) {
      const diff = moment().diff(paymentDate, 'month')
      const red = diff >= 3
      const yellow = diff >= 2 && diff < 3
      let status
      if (red) {
        status = 'red'
      } else if (yellow) {
        status = 'yellow'
      } else {
        status = ''
      }
      return `<span class="bb-table-kpi-services bb-table-kpi-services_${status}">${serviceName}</span>`
    },
    async getUserData () {
      this.loaderRun = true
      this.userInfo = await this.getUser()
      const kpi = get(this.userInfo, ['position', 'kpi'], false)
      if (!kpi) {
        this.loaderRun = false
        return
      }
      const department = get(this.userInfo, ['position', 'department'], 0)
      const id = this.$route.params.id
      this.userKpi = await this.getKpiUsers(department, id)
      this.loaderRun = false
    },
    async getUser () {
      try {
        const { data } = await UsersListApi.getUser(this.$route.params.id)
        return data
      } catch (err) {
        console.error(err)
      }
    },
    async getKpiUsers (department, id) {
      try {
        const { data } = await KpiApi.getUsersKPI(department, id)
        return data
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.getUserData()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bb-user-card {
    @include global-font;
    position: relative;
    display: grid;
    grid-template-columns: 333px 1fr;
    height: calc(100% + 20px);
    margin: -10px -20px;
    z-index: 1;

    &-modal {
      width: 70vw;
      min-width: 1200px;
      min-height: calc(100%);
      margin-right: 4px;

      &-total {
        display: flex;
        justify-content: flex-end;
        margin-right: 25px;
        margin-bottom: 8px;

        &__text {
          padding: 10px 10px;
          border-radius: 5px;
          background: rgba($color-denim, 0.15);
          color: $color-denim;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
        }
      }

      &_balance {
        width: auto;
        min-width: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      &__title {
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 19px;
      }

      &__btn {
        text-transform: uppercase;
        width: 117px;
        margin: 20px auto auto;
      }
    }

    &-left {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-right: 15px;
      max-height: 100%;
      z-index: 1;

      &_active {
        z-index: 2;
      }

      &-body {
        width: 100%;
      }
    }

    &-right {
      position: relative;
      width: 100%;
      max-height: 100%;
      z-index: 1;

      &-info-one {
        display: grid;
        grid-template-columns: minmax(440px, 1fr) minmax(104px, 304px);
        grid-gap: 20px;

        &__chart {
          background: $color-white;
          border-radius: 6px;
          grid-row: 1/4;
        }
      }

      &-info-two {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        margin-top: 18px;

        &__item {
          height: 100%;
          background: $color-white;
          border-radius: 6px;
          padding: 20px 20px;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 17px;
          text-transform: uppercase;
          color: $color-denim;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/UserCard/UserCard.vue